import PictureV1 from "../../../../components/form_builder/elements/picture/PictureV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-picture-v1",
  component: PictureV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      value: "",
      required: false,
      hidden: false,
      style: {},
      eFormEditable: true,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) =>
      value
        ? `
    <div>
      <img width="83" height="50" src="${value.picture}" />
    </div>`
        : ""
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
